import { AdminApi } from 'stylemix-vue-admin'

export default class DispatchApi extends AdminApi {
  constructor(parameters) {
    super('dispatch_system', parameters)
  }

  getDrivers(bounds, all = false, company_id = null) {
    let params = { min_lat: bounds.min_lat, max_lat: bounds.max_lat, min_lng: bounds.min_lng, max_lng: bounds.max_lng }
    if(company_id) params.company_id = company_id;
    if(all) params.all = true;
    return this.submit('post', `/location/vehicles`, params)
  }

  getSettings() {
    return this.submit('get', `/location/settings`)
  }

  save(data) {
    return this.submit('POST', `location/settings`, data)
  }
}
